import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import logo from "../assets/images/logo.svg";

import "../assets/css/Header.css";

const Header = () => {
  const location = useLocation();

  useEffect(() => {
    const navbar = document.getElementById("mainNavbar");

    const handleScroll = () => {
      if (window.pageYOffset >= 200) {
        navbar.classList.add("sticky-top");
        document.body.classList.add("fixed-nav");
      } else {
        navbar.classList.remove("sticky-top");
        document.body.classList.remove("fixed-nav");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  return (
    <div className="site-top">
      <nav
        id="mainNavbar"
        className="navbar navbar-expand-lg navbar-light bg-light"
      >
        <div className="container">
          
          {/* Logo */}
          <Link
            className="navbar-brand"
            to="/"
          >
            <img
              src={logo}
              alt="company logo"
              className="logo-img"
            />
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler headbutton"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              
              <li className="nav-item">
                <Link
                  className={`nav-link mobiletext ${
                    location.pathname === "/"
                      ? "active"
                      : ""
                  }`}
                  to="/"
                >
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link mobiletext ${
                    location.pathname ===
                    "/about-us"
                      ? "active"
                      : ""
                  }`}
                  to="/about-us"
                >
                  About Us
                </Link>
              </li>

              {/* <li className="nav-item">
                <Link
                  className={`nav-link mobiletext ${
                    location.pathname ===
                    "/careers"
                      ? "active"
                      : ""
                  }`}
                  to="/careers"
                >
                  Career
                </Link>
              </li> */}

              <li className="nav-item">
                <Link
                  className={`nav-link mobiletext ${
                    location.pathname ===
                    "/contact-us"
                      ? "active"
                      : ""
                  }`}
                  to="/contact-us"
                >
                  Contact Us
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;